import { render } from "./ProductsTable.vue?vue&type=template&id=a8d7efd2"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ProductsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8d7efd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8d7efd2', __exports__)) {
    api.reload('a8d7efd2', __exports__)
  }
  
  module.hot.accept("./ProductsTable.vue?vue&type=template&id=a8d7efd2", () => {
    api.rerender('a8d7efd2', render)
  })

}


export default __exports__